import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'
import { addCommonTranslations } from "../../common/js/i18n";

i18n
    .use(initReactI18next)
    .init({
        lng: document.documentElement.lang,
        fallbackLng: 'fr',
        react: {
            useSuspense: false,
        },
    })

addCommonTranslations(i18n);

export default i18n
